'use client';
import * as React from 'react';

const DefaultSendIcon = React.memo(function DefaultSendIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      style={{ width: '1em', height: '1em' }}
    >
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
    </svg>
  );
});

export default DefaultSendIcon;
